import { destroy, get, patch, post } from "./ServicesApi";


// api/filterManagement.js
const createFilterKey = (body) => {
  return post(`/v1/key-store`, body);
};

const getFilterByKey = (key) => {
  return get(`/v1/key-store/${key}`);
};

const listUserFilters = (keyPattern) => {
  return get(`/v1/key-store/${keyPattern}/list`);
};

const deleteFilterByKey = (key) => {
  return destroy(`/v1/key-store/${encodeURIComponent(key)}`);
};

export {
  createFilterKey,
  getFilterByKey,
  listUserFilters,
  deleteFilterByKey,
};
